package com.bikompanion.ui.home

import androidx.compose.runtime.Composable
import androidx.navigation3.runtime.NavEntry
import androidx.navigation3.scene.Scene

/**
 * The only scene the home screen has: the map entry, drawn the same whether or not a station is on
 * top of it.
 *
 * The key never changes, so opening or closing a station is not a scene change. That keeps
 * `NavDisplay` from animating between two copies of the map or tearing it down, which would reset
 * the camera. A [StationRoute] entry draws nothing here; its sheet is part of the map entry's
 * content because it sits on the same haze layer and is docked against the same insets.
 */
internal data class HomeScene(
    override val entries: List<NavEntry<HomeRoute>>,
    override val previousEntries: List<NavEntry<HomeRoute>>,
) : Scene<HomeRoute> {
    override val key: Any = HomeSceneKey

    override val content: @Composable () -> Unit = {
        entries.first().Content()
    }
}

private data object HomeSceneKey
